import React, { FC, useMemo } from 'react';
import PublicPostPreviewsList from 'components/publicPreviews/post/PublicPostPreviewsList';
import { parseQueryParamToNumbers } from 'utils/url';
import { modalRoutes } from 'constants/routes';
import PublicInviteUser from 'pages/PublicInviteUser';
import ModalRoute, { ModalRouteProps } from 'context/ModalRouter';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { Alert, KontentinoLogo } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';

export const PublicPostOverview: FC = () => {
  const { postId } = useParams<{ postId: string | undefined }>();
  const [search] = useSearchParams();
  const { t } = useTranslation();

  const { ids, token } = useMemo(() => {
    const ids: number[] = [
      ...parseQueryParamToNumbers(postId),
      ...parseQueryParamToNumbers(search.get('ids')),
    ];

    const token = search.get('token') || '';

    return { ids, token };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="tw-w-full tw-bg-accent-100">
      <div className="tw-mx-auto tw-w-full tw-max-w-[720px] tw-px-4 tw-pt-8 md:tw-pt-10">
        <a
          href="https://www.kontentino.com"
          target="_blank"
          rel="noopener noreferrer"
          className="tw-inline-block"
          title="Kontentino"
        >
          <KontentinoLogo
            variant="primary-label"
            className="tw-h-[20px] tw-w-auto"
          />
        </a>
      </div>
      {!!token && ids.length > 0 ? (
        <PublicPostPreviewsList token={token} ids={ids} />
      ) : (
        <div className="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-px-4">
          <Alert variant="danger" className="!tw-w-auto">
            {t('publicPostsSomethingWentWrong')}
          </Alert>
        </div>
      )}
      <ModalRoute
        path={modalRoutes.PUBLIC_INVITE_USER}
        component={useMemo(
          () => (props: ModalRouteProps) =>
            <PublicInviteUser token={token} {...props} />,
          [token],
        )}
      />
    </div>
  );
};
